import { WebsiteIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
export const WebDataSourceButton = ({
  children,
  source
}) => {
  // TODO: Can we make primaryText a nicer version of the domain?
  // TODO: Populate icon with relevant icon (BE says it may be doable with enrichment)

  return children({
    primaryText: source.domain || source.url,
    secondaryText: source.domain ? source.url : undefined,
    icon: /*#__PURE__*/_jsx(WebsiteIcon, {}),
    onSourceClick: () => {
      window.open(source.url, '_blank', 'noopener,noreferrer');
    }
  });
};